import React from 'react';
import { NavLink } from 'react-router-dom';
import type { NavItem } from '../config/navConfig';

export interface NavViewItemProps {
  item: NavItem;
  isActive: boolean;
  onClick?: () => void;
}

/**
 * Renders a single navigation link within a view group.
 * Wraps NavLink with consistent styling and badge support.
 */
export function NavViewItem({ item, isActive, onClick }: NavViewItemProps) {
  const isNotifBadge = item.path === '/announcements' && item.badge != null;

  return (
    <NavLink
      to={item.path}
      onClick={onClick}
      style={() => ({
        ...styles.navItem,
        ...(isActive ? styles.navItemActive : {}),
      })}
    >
      <span style={styles.navIcon}>{item.icon}</span>
      <span style={styles.label}>{item.label}</span>
      {item.badge != null && (
        <span style={isNotifBadge ? styles.badgeRed : styles.badge}>{item.badge}</span>
      )}
    </NavLink>
  );
}

const styles: Record<string, React.CSSProperties> = {
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    color: '#a3b8a9',
    fontSize: '14px',
    fontWeight: 500,
    textDecoration: 'none',
    transition: 'all 0.2s',
    position: 'relative',
    border: '1px solid transparent',
  },
  navItemActive: {
    background: 'linear-gradient(135deg, rgba(26,107,60,0.2), rgba(201,168,76,0.1))',
    color: '#c9a84c',
    border: '1px solid rgba(201,168,76,0.2)',
  },
  navIcon: {
    fontSize: '18px',
    width: '24px',
    textAlign: 'center',
  },
  label: {
    flex: 1,
  },
  badge: {
    backgroundColor: '#c9a84c',
    color: '#0f2d1f',
    fontSize: '10px',
    fontWeight: 700,
    padding: '2px 6px',
    borderRadius: '10px',
  },
  badgeRed: {
    backgroundColor: '#e53935',
    color: '#ffffff',
    fontSize: '10px',
    fontWeight: 700,
    padding: '2px 7px',
    borderRadius: '10px',
    boxShadow: '0 0 6px rgba(229,57,53,0.5)',
    animation: 'pulse-badge 2s infinite',
  },
};
